module.exports = __webpack_public_path__ + "img/pg.7f40fb40.svg";